import { PRELOADER_ID, PRELOADER_VIEW_DELAY_MS } from 'constants/preloader';

const removePreloader = (preloader: HTMLElement) => {
  setTimeout(() => {
    preloader.classList.add('preloader-fade-out');
    setTimeout(() => {
      preloader.remove();
    }, PRELOADER_VIEW_DELAY_MS / 3);
  }, PRELOADER_VIEW_DELAY_MS);
};

const waitForContentVisible = (): Promise<void> =>
  new Promise((resolve) => {
    const check = () => {
      const content = document.querySelector('#root > *') as HTMLElement;
      if (content?.offsetHeight > 0) {
        resolve();
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  });

const onRenderCallback = async () => {
  const preloader = document.getElementById(PRELOADER_ID);

  if (!preloader) {
    return;
  }

  await waitForContentVisible();

  removePreloader(preloader);
};

export { onRenderCallback };
